export default __webpack_public_path__ + "static/media/ancHead.47bb82f0.png";